import React from 'react';
import { StickyNote, Plus, X } from 'lucide-react';
import { Button } from '../../../../components/ui/button';
import { Textarea } from '../../../../components/ui/textarea';

export const NotesTab = ({ clientDetail, newNote, setNewNote, onAddNote, onDeleteNote }) => (
  <div className="mt-4">
    <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-3 mb-4">
      <p className="text-sm text-yellow-800 flex items-center gap-2">
        <StickyNote className="h-4 w-4" />
        <strong>Admin-only notes</strong> - Not visible to clients
      </p>
    </div>

    <div className="mb-4">
      <Textarea
        placeholder="Add a note about this client..."
        value={newNote}
        onChange={(e) => setNewNote(e.target.value)}
        rows={3}
      />
      <Button className="mt-2 bg-amber-500 hover:bg-amber-600" onClick={onAddNote} disabled={!newNote.trim()}>
        <Plus className="h-4 w-4 mr-2" />
        Add Note
      </Button>
    </div>

    {clientDetail.admin_notes?.length > 0 ? (
      <div className="space-y-3">
        {clientDetail.admin_notes.map((note) => (
          <div key={note.id} className="p-3 bg-gray-50 rounded-lg border-l-4 border-amber-400">
            <div className="flex justify-between items-start">
              <div className="flex-1">
                <p className="text-sm text-gray-700 whitespace-pre-wrap">{note.content}</p>
                <p className="text-xs text-gray-400 mt-2">
                  {note.created_by} • {new Date(note.created_at).toLocaleString()}
                </p>
              </div>
              <Button
                variant="ghost"
                size="icon"
                className="text-gray-400 hover:text-red-500"
                onClick={() => onDeleteNote(note.id)}
              >
                <X className="h-4 w-4" />
              </Button>
            </div>
          </div>
        ))}
      </div>
    ) : (
      <div className="text-center py-8 text-gray-500">
        <StickyNote className="h-12 w-12 mx-auto mb-3 text-gray-300" />
        <p>No notes yet</p>
      </div>
    )}
  </div>
);
